<div class="page-container">
    <div class="page-header">
        <div class="header-content">
            <h1 class="page-title">Truck Settings</h1>
            <p class="page-subtitle">Manage truck-related configuration options</p>
        </div>
    </div>

    <!-- Loading Spinner -->
    <div *ngIf="isLoading" class="loading-overlay">
        <mat-spinner diameter="50" color="primary"></mat-spinner>
        <p class="loading-text">Loading settings...</p>
    </div>

    <div class="settings-grid" [class.loading]="isLoading">
        <!-- Type of Truck -->
        <div class="setting-card">
            <div class="card-header">
                <div class="header-icon">
                    <mat-icon>local_shipping</mat-icon>
                </div>
                <div class="header-text">
                    <h3 class="card-title">Type of Truck</h3>
                    <p class="card-subtitle">Manage available truck types</p>
                </div>
            </div>

            <div class="card-body">
                <div class="input-row">
                    <input
                        class="modern-input"
                        type="text"
                        [formControl]="searchControl"
                        placeholder="Enter truck type name"
                        (keyup.enter)="addTypeOfTrucks()" />
                    <button
                        (click)="addTypeOfTrucks()"
                        type="button"
                        class="btn-add">
                        <mat-icon>add</mat-icon>
                        <span>Add</span>
                    </button>
                </div>

                <div class="items-grid" *ngIf="typeOfTrucks.length > 0">
                    <div *ngFor="let item of typeOfTrucks" class="item-chip">
                        <span class="item-name">{{ item.name }}</span>
                        <button type="button" class="btn-remove" (click)="removeTypeOfTrucks(item)">
                            <mat-icon>close</mat-icon>
                        </button>
                    </div>
                </div>

                <div *ngIf="typeOfTrucks.length === 0" class="empty-state">
                    <mat-icon>inventory_2</mat-icon>
                    <p>No truck types added yet</p>
                </div>
            </div>
        </div>

        <!-- Truck Model -->
        <div class="setting-card">
            <div class="card-header">
                <div class="header-icon">
                    <mat-icon>settings</mat-icon>
                </div>
                <div class="header-text">
                    <h3 class="card-title">Truck Model</h3>
                    <p class="card-subtitle">Manage truck model numbers</p>
                </div>
            </div>

            <div class="card-body">
                <div class="input-row">
                    <input
                        class="modern-input"
                        type="text"
                        [formControl]="searchControl"
                        placeholder="Enter truck model"
                        (keyup.enter)="addTruckModels()" />
                    <button
                        (click)="addTruckModels()"
                        type="button"
                        class="btn-add">
                        <mat-icon>add</mat-icon>
                        <span>Add</span>
                    </button>
                </div>

                <div class="items-grid" *ngIf="truckModels.length > 0">
                    <div *ngFor="let item of truckModels" class="item-chip">
                        <span class="item-name">{{ item.name }}</span>
                        <button type="button" class="btn-remove" (click)="removeTruckModels(item)">
                            <mat-icon>close</mat-icon>
                        </button>
                    </div>
                </div>

                <div *ngIf="truckModels.length === 0" class="empty-state">
                    <mat-icon>inventory_2</mat-icon>
                    <p>No truck models added yet</p>
                </div>
            </div>
        </div>

        <!-- Loading Capacity -->
        <div class="setting-card">
            <div class="card-header">
                <div class="header-icon">
                    <mat-icon>scale</mat-icon>
                </div>
                <div class="header-text">
                    <h3 class="card-title">Loading Capacity</h3>
                    <p class="card-subtitle">Define truck loading capacities</p>
                </div>
            </div>

            <div class="card-body">
                <div class="input-row">
                    <input
                        class="modern-input"
                        type="text"
                        [formControl]="searchControl"
                        placeholder="Enter capacity (e.g., 5 tons)"
                        (keyup.enter)="addTruckLoadingCapacity()" />
                    <button
                        (click)="addTruckLoadingCapacity()"
                        type="button"
                        class="btn-add">
                        <mat-icon>add</mat-icon>
                        <span>Add</span>
                    </button>
                </div>

                <div class="items-grid" *ngIf="truckLoandingCapacity.length > 0">
                    <div *ngFor="let item of truckLoandingCapacity" class="item-chip">
                        <span class="item-name">{{ item.name }}</span>
                        <button type="button" class="btn-remove" (click)="removeTruckLoadingCapacity(item)">
                            <mat-icon>close</mat-icon>
                        </button>
                    </div>
                </div>

                <div *ngIf="truckLoandingCapacity.length === 0" class="empty-state">
                    <mat-icon>inventory_2</mat-icon>
                    <p>No capacities added yet</p>
                </div>
            </div>
        </div>

        <!-- Box Size -->
        <div class="setting-card">
            <div class="card-header">
                <div class="header-icon">
                    <mat-icon>straighten</mat-icon>
                </div>
                <div class="header-text">
                    <h3 class="card-title">Box Size</h3>
                    <p class="card-subtitle">Manage available box sizes</p>
                </div>
            </div>

            <div class="card-body">
                <div class="input-row">
                    <input
                        class="modern-input"
                        type="text"
                        [formControl]="searchControl"
                        placeholder="Enter box size"
                        (keyup.enter)="addBoxSizes()" />
                    <button
                        (click)="addBoxSizes()"
                        type="button"
                        class="btn-add">
                        <mat-icon>add</mat-icon>
                        <span>Add</span>
                    </button>
                </div>

                <div class="items-grid" *ngIf="boxSizes.length > 0">
                    <div *ngFor="let item of boxSizes" class="item-chip">
                        <span class="item-name">{{ item.name }}</span>
                        <button type="button" class="btn-remove" (click)="removeBoxSize(item)">
                            <mat-icon>close</mat-icon>
                        </button>
                    </div>
                </div>

                <div *ngIf="boxSizes.length === 0" class="empty-state">
                    <mat-icon>inventory_2</mat-icon>
                    <p>No box sizes added yet</p>
                </div>
            </div>
        </div>

        <!-- Box Loading Type -->
        <div class="setting-card">
            <div class="card-header">
                <div class="header-icon">
                    <mat-icon>category</mat-icon>
                </div>
                <div class="header-text">
                    <h3 class="card-title">Box Loading Type</h3>
                    <p class="card-subtitle">Define box loading methods</p>
                </div>
            </div>

            <div class="card-body">
                <div class="input-row">
                    <input
                        class="modern-input"
                        type="text"
                        [formControl]="searchControl"
                        placeholder="Enter loading type"
                        (keyup.enter)="addBoxLoadingType()" />
                    <button
                        (click)="addBoxLoadingType()"
                        type="button"
                        class="btn-add">
                        <mat-icon>add</mat-icon>
                        <span>Add</span>
                    </button>
                </div>

                <div class="items-grid" *ngIf="boxLoadingType.length > 0">
                    <div *ngFor="let item of boxLoadingType" class="item-chip">
                        <span class="item-name">{{ item.name }}</span>
                        <button type="button" class="btn-remove" (click)="removeBoxLoadingType(item)">
                            <mat-icon>close</mat-icon>
                        </button>
                    </div>
                </div>

                <div *ngIf="boxLoadingType.length === 0" class="empty-state">
                    <mat-icon>inventory_2</mat-icon>
                    <p>No loading types added yet</p>
                </div>
            </div>
        </div>

        <!-- Vehicle Maintenance -->
        <div class="setting-card">
            <div class="card-header">
                <div class="header-icon">
                    <mat-icon>build</mat-icon>
                </div>
                <div class="header-text">
                    <h3 class="card-title">Vehicle Maintenance</h3>
                    <p class="card-subtitle">Maintenance categories</p>
                </div>
            </div>

            <div class="card-body">
                <div class="input-row">
                    <input
                        class="modern-input"
                        type="text"
                        [formControl]="searchControl"
                        placeholder="Enter maintenance type"
                        (keyup.enter)="addVehicleMaintenance()" />
                    <button
                        (click)="addVehicleMaintenance()"
                        type="button"
                        class="btn-add">
                        <mat-icon>add</mat-icon>
                        <span>Add</span>
                    </button>
                </div>

                <div class="items-grid" *ngIf="vehicleMaintenances.length > 0">
                    <div *ngFor="let item of vehicleMaintenances" class="item-chip">
                        <span class="item-name">{{ item.name }}</span>
                        <button type="button" class="btn-remove" (click)="removeVehicleMaintenance(item)">
                            <mat-icon>close</mat-icon>
                        </button>
                    </div>
                </div>

                <div *ngIf="vehicleMaintenances.length === 0" class="empty-state">
                    <mat-icon>inventory_2</mat-icon>
                    <p>No maintenance types added yet</p>
                </div>
            </div>
        </div>

        <!-- Incident Report -->
        <div class="setting-card">
            <div class="card-header">
                <div class="header-icon">
                    <mat-icon>report_problem</mat-icon>
                </div>
                <div class="header-text">
                    <h3 class="card-title">Incident Report</h3>
                    <p class="card-subtitle">Incident report categories</p>
                </div>
            </div>

            <div class="card-body">
                <div class="input-row">
                    <input
                        class="modern-input"
                        type="text"
                        [formControl]="searchControl"
                        placeholder="Enter incident type"
                        (keyup.enter)="addIncidentReport()" />
                    <button
                        (click)="addIncidentReport()"
                        type="button"
                        class="btn-add">
                        <mat-icon>add</mat-icon>
                        <span>Add</span>
                    </button>
                </div>

                <div class="items-grid" *ngIf="incidentReport.length > 0">
                    <div *ngFor="let item of incidentReport" class="item-chip">
                        <span class="item-name">{{ item.name }}</span>
                        <button type="button" class="btn-remove" (click)="removeIncidentReport(item)">
                            <mat-icon>close</mat-icon>
                        </button>
                    </div>
                </div>

                <div *ngIf="incidentReport.length === 0" class="empty-state">
                    <mat-icon>inventory_2</mat-icon>
                    <p>No incident types added yet</p>
                </div>
            </div>
        </div>

        <!-- Route Expertise -->
        <div class="setting-card">
            <div class="card-header">
                <div class="header-icon">
                    <mat-icon>route</mat-icon>
                </div>
                <div class="header-text">
                    <h3 class="card-title">Route Expertise</h3>
                    <p class="card-subtitle">Define route categories</p>
                </div>
            </div>

            <div class="card-body">
                <div class="input-row">
                    <input
                        class="modern-input"
                        type="text"
                        [formControl]="searchControl"
                        placeholder="Enter route type"
                        (keyup.enter)="addRouteExpertise()" />
                    <button
                        (click)="addRouteExpertise()"
                        type="button"
                        class="btn-add">
                        <mat-icon>add</mat-icon>
                        <span>Add</span>
                    </button>
                </div>

                <div class="items-grid" *ngIf="routeExpertise.length > 0">
                    <div *ngFor="let item of routeExpertise" class="item-chip">
                        <span class="item-name">{{ item.name }}</span>
                        <button type="button" class="btn-remove" (click)="removeRouteExpertise(item)">
                            <mat-icon>close</mat-icon>
                        </button>
                    </div>
                </div>

                <div *ngIf="routeExpertise.length === 0" class="empty-state">
                    <mat-icon>inventory_2</mat-icon>
                    <p>No route types added yet</p>
                </div>
            </div>
        </div>

        <!-- Insurance Types -->
        <div class="setting-card">
            <div class="card-header">
                <div class="header-icon">
                    <mat-icon>shield</mat-icon>
                </div>
                <div class="header-text">
                    <h3 class="card-title">Insurance Types</h3>
                    <p class="card-subtitle">Manage insurance categories</p>
                </div>
            </div>

            <div class="card-body">
                <div class="input-row">
                    <input
                        class="modern-input"
                        type="text"
                        [formControl]="searchControl"
                        placeholder="Enter insurance type"
                        (keyup.enter)="addInsuranceType()" />
                    <button
                        (click)="addInsuranceType()"
                        type="button"
                        class="btn-add">
                        <mat-icon>add</mat-icon>
                        <span>Add</span>
                    </button>
                </div>

                <div class="items-grid" *ngIf="insuranceTypes.length > 0">
                    <div *ngFor="let item of insuranceTypes" class="item-chip">
                        <span class="item-name">{{ item.name }}</span>
                        <button type="button" class="btn-remove" (click)="removeInsuranceType(item)">
                            <mat-icon>close</mat-icon>
                        </button>
                    </div>
                </div>

                <div *ngIf="insuranceTypes.length === 0" class="empty-state">
                    <mat-icon>inventory_2</mat-icon>
                    <p>No insurance types added yet</p>
                </div>
            </div>
        </div>

        <!-- Security Deposit Amount -->
        <div class="setting-card">
            <div class="card-header">
                <div class="header-icon">
                    <mat-icon>account_balance_wallet</mat-icon>
                </div>
                <div class="header-text">
                    <h3 class="card-title">Security Deposit</h3>
                    <p class="card-subtitle">Define deposit amounts</p>
                </div>
            </div>

            <div class="card-body">
                <div class="input-row">
                    <input
                        class="modern-input"
                        type="text"
                        [formControl]="searchControl"
                        placeholder="Enter deposit amount"
                        (keyup.enter)="addSecurityDepositAmount()" />
                    <button
                        (click)="addSecurityDepositAmount()"
                        type="button"
                        class="btn-add">
                        <mat-icon>add</mat-icon>
                        <span>Add</span>
                    </button>
                </div>

                <div class="items-grid" *ngIf="securityDepositAmount.length > 0">
                    <div *ngFor="let item of securityDepositAmount" class="item-chip">
                        <span class="item-name">{{ item.name }}</span>
                        <button type="button" class="btn-remove" (click)="removeSecurityDepositAmount(item)">
                            <mat-icon>close</mat-icon>
                        </button>
                    </div>
                </div>

                <div *ngIf="securityDepositAmount.length === 0" class="empty-state">
                    <mat-icon>inventory_2</mat-icon>
                    <p>No deposit amounts added yet</p>
                </div>
            </div>
        </div>
    </div>
</div>
